import { ReactNode, useEffect, useState } from "react";
import cn from "classnames";
import { ReactComponent as Up } from "../../assets/icons/caretUp.svg";
import { ReactComponent as Down } from "../../assets/icons/caretDown.svg";
import styles from "./dropdown.module.css";

interface DropdownProps {
  className?: string;
  title?: string | ReactNode;
  content?: ReactNode;
  open?: boolean;
}

export const Dropdown = ({ className, title, content, open: openState }: DropdownProps) => {
  const [open, setOpen] = useState<boolean>(openState !== undefined ? openState : true);

  useEffect(() => {
    if (openState !== undefined) {
      setOpen(openState);
    }
  }, [openState]);

  const toggleOpen = () => {
    setOpen(!open);
  };

  return (
    <div className={cn(styles.container, open && styles.containerOpen, className)}>
      <div className={styles.titleContainer} onClick={toggleOpen}>
        {typeof title === "string" ? <span className={styles.titleText}>{title}</span> : title}
        {open ? <Up className={styles.icon} /> : <Down className={styles.icon} />}
      </div>
      <div className={cn(styles.content, !open && styles.contentClose)}>{content}</div>
    </div>
  );
};
